import React from 'react';
import { ShortlistedProfile } from '../../../../api/DTO/ShortlistedProfile';
import { useAiSearchProfilePopoutContext } from '../../../AiSearchProfilePopout/AiSearchProfilePopoutContext';

const CandidateCell = (data: ShortlistedProfile) => {
    const { openProfilePopout } = useAiSearchProfilePopoutContext();
    const { id, profile, searchCriteriaScores } = data;

    const handleOnClick = () => {
        openProfilePopout({
            id,
            education: profile.education,
            experience: profile.experience,
            location: profile.location,
            name: profile.name,
            about: profile.about,
            url: profile.url,
            searchCriteriaScores,
            languages: profile.languages,
            emailSentCount: data.emailSentCount,
        });
    };

    return (
        <div
            data-cy="candidateCell"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                e.preventDefault();
                if (e.key === 'Enter' || e.key === ' ') {
                    handleOnClick();
                }
            }}
            className="text-primary cursor-pointer overflow-hidden text-sm font-bold text-ellipsis transition-colors duration-150 hover:underline"
            onClick={handleOnClick}
        >
            {profile.name || ''}
        </div>
    );
};

export default CandidateCell;
